import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import autoBind from 'react-autobind';
import classnames from 'classnames';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, FieldArray } from 'redux-form';

import Button from 'ui/common/button';
import FormError from 'ui/common/form/form-error';

import TextField from 'ui/common/form/fields/text-field';
import SimpleSelectField from 'ui/common/form/fields/simple-select-field';
import validator from 'ui/common/form/validator';
import Icon from 'ui/common/icon';

import {
  socialLinkTypeIdsOrderForProfile,
  socialLinkTypes,
  defaultSocialLinksForProfile,
} from 'ui/common/social-links';

import fields, { fieldNames, asyncFields, socialLinkFieldNames, socialLinkModel } from './model';
import * as messages from './messages';
import {
  selectCurrentUser,
  selectCurrentUsername,
  selectCurrentUserHasAutoGeneratedUsername,
} from 'store/features/auth/selectors';
import { updateCurrentUser } from 'store/features/auth/actions';

export const FORM_NAME = 'update-social-links-form';
const rootValidator = validator(fields);
const asyncValidator = validator.async(asyncFields);
const noopPromise = new Promise((resolve, reject) => resolve());

function asyncValidate(values, ownProps) {
  const { currentUserUsername } = ownProps;
  if (currentUserUsername) return noopPromise;

  return asyncValidator(values).then((success, errors) => {
    if (errors) throw errors;
  });
}

function validate(values) {
  let errors = rootValidator(values) || {};
  errors[fieldNames.socialLinks] = (values[fieldNames.socialLinks] || []).map(socialLink =>
    validator(socialLinkModel(socialLink ? socialLink.type : null))(socialLink)
  );
  return errors;
}

class UpdateSocialLinksForm extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  renderSocialLinks({ fields, meta }) {
    const { intl: { formatMessage } } = this.props;

    const socialLinkTypeOptions = socialLinkTypeIdsOrderForProfile.map(socialLinkTypeId => ({
      text: formatMessage(socialLinkTypes[socialLinkTypeId].messages.name),
      value: socialLinkTypeId,
    }));

    return (
      <div>
        <div className="d-flex justify-content-between align-items-center">
          <label>{formatMessage(messages.labels[fieldNames.socialLinks])}</label>
        </div>
        {fields.map((socialLink, index) => {
          return (
            <div key={index} className="row justify-content-between py-2">
              <div className="col-12 col-md-4 col-lg-4">
                <Field
                  name={`${socialLink}.${socialLinkFieldNames.type}`}
                  component={SimpleSelectField}
                  options={socialLinkTypeOptions}
                />
              </div>
              <div className="col-8 col-md-5 col-lg-6">
                <Field
                  wrapperClass="pb-0"
                  name={`${socialLink}.${socialLinkFieldNames.url}`}
                  component={TextField}
                />
              </div>

              <div className="col-4 col-md-3 col-lg-2 text-right">
                <Button
                  className="pt-2"
                  color="info"
                  icon="fa fa-trash"
                  isReady={false}
                  onClick={() => fields.remove(index)}
                />
              </div>
            </div>
          );
        })}
        <div className="row py-2">
          <div className="col-8 col-md-9 col-lg-10">
            <div className="d-flex ">
              {/* Start Add new link button */}
              <div className="list-inline m-0">
                <div className="list-inline-item">
                  <Icon
                    name="fa fa-plus"
                    background
                    className="m-0"
                    onClick={() => fields.push(defaultSocialLinksForProfile[0])}
                  />
                </div>
                <div className="list-inline-item text-muted">Add another link</div>
              </div>
              {/* End Add new link button */}
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { className, handleSubmit, form: formName, intl: { formatMessage } } = this.props;

    return (
      <div className={className}>
        <div className={classnames('row align-items-center')}>
          <div className="col-12">
            <form title={formatMessage(messages.header.title)} onSubmit={handleSubmit}>
              <FormError formName={formName} />
              <div className="">
                <FieldArray name={fieldNames.socialLinks} component={this.renderSocialLinks} />
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const currentUser = selectCurrentUser(state);
  const currentUserUsername = selectCurrentUsername(state);
  const currentUserHasAutoGeneratedUsername = selectCurrentUserHasAutoGeneratedUsername(state);
  const { imgUrl, socialLinks } = currentUser;
  const newSocialLinks = socialLinks || defaultSocialLinksForProfile.slice(0, 1);
  const originalOnSubmit = ownProps ? ownProps.onSubmit : null;
  let onSubmit = originalOnSubmit;

  if (originalOnSubmit) {
    const modalSubmit = values => {
      if (currentUserUsername) delete values[fieldNames.username];
      originalOnSubmit(values);
    };
    onSubmit = modalSubmit;
  }

  return {
    initialValues: {
      socialLinks: newSocialLinks,
    },
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    currentUserUsername,
    currentUserHasAutoGeneratedUsername,
    currentUserImageUrl: imgUrl,
    onSubmit,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateCurrentUser: {
      request: bindActionCreators(updateCurrentUser.request, dispatch),
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: FORM_NAME,
    validate,
    asyncBlurFields: [fieldNames.username],
    asyncValidate,
  })(injectIntl(UpdateSocialLinksForm))
);



// WEBPACK FOOTER //
// ./src/ui/graphql/UpdateSocialLinks/form.js